import React from 'react';
import * as util from '../../../util';

type Props = {
    id: string;
    ariaLabel: string;
    styleBlack?: boolean;
    useMargin?: boolean;
    onClick?: () => void;
};

const InfoIcon: React.FC<Props> = ({id, ariaLabel, useMargin, styleBlack, onClick}) => {
    const click = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        util.modal(id);
        onClick?.();
    };

    return (
        <button
            type="button"
            className="info-button"
            aria-haspopup="dialog"
            aria-controls={id}
            aria-label={ariaLabel}
            style={{marginLeft: useMargin ? 5 : undefined}}
            onClick={click}
        >
            <i
                className="far fa-info-circle"
                style={{color: styleBlack ? '#222' : undefined}}
            />
        </button>
    );
};

export default InfoIcon;
